import { ColumnDef } from "@tanstack/react-table";
import { TableCell } from "@/components/ui/table";
import { ChevronRight } from "lucide-react";
import { CellHoverClassName } from "@/components/List/ListTable/TableBody/Rows/TableDataRow";

type ExpandColumnOptions<T> = Partial<ColumnDef<T>> & {
	className?: string;
};

export const ExpandColumn = <T,>({ className = "", meta = {} }: ExpandColumnOptions<T> = {}): ColumnDef<T> => {
	const mergedMeta = {
		wrapWithTableCell: false,
		cellClassName: className,
		...meta,
	};

	return {
		id: "expander",
		enableHiding: false,
		meta: mergedMeta,
		header: () => null,
		cell: ({ row }) => {
			const isExpanded = row.getIsExpanded();

			return (
				<TableCell className={`${CellHoverClassName} ${mergedMeta?.cellClassName} w-8`}>
					<ChevronRight
						className={`h-3.5 w-3.5 text-gray-400 transition-transform duration-200 ${
							isExpanded ? "rotate-90" : ""
						}`}
					/>
				</TableCell>
			);
		},
	};
};
